import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';

// Section wrapper với id ổn định để TOC anchor link.
export const LegalSection = ({ id, title, children }) => (
  <Box as="section" id={id} scrollMarginTop="80px" pt={6} pb={2}>
    <Heading
      as="h2"
      fontSize={{ base: 'lg', md: 'xl' }}
      fontWeight="700"
      color="text.primary"
      mb={3}
      lineHeight="1.3"
    >
      {title}
    </Heading>
    <Box color="text.secondary" fontSize={{ base: 'sm', md: 'md' }} lineHeight="1.75">
      {children}
    </Box>
  </Box>
);

export const LegalParagraph = ({ children, ...rest }) => (
  <Text mb={4} {...rest}>
    {children}
  </Text>
);

export const LegalList = ({ items }) => (
  <VStack as="ul" align="stretch" spacing={2} pl={5} mt={2} mb={4} listStyleType="disc">
    {items.map((item, i) => (
      <Box as="li" key={i} color="text.secondary" fontSize={{ base: 'sm', md: 'md' }} lineHeight="1.7">
        {item}
      </Box>
    ))}
  </VStack>
);

export default LegalSection;
